import { createLogic } from "redux-logic";
import * as History from "../../../../../common-deprecated/History";
import type { CarConfigLogicType } from "../store";
import { setActiveSection } from "../slices/CarConfigNavigationSlice";
import { isRetailer } from "../../../../../common-deprecated/utils";

// Works in conjunction with useAphNavigationRetailer hook
const setActiveSectionLogic = (createLogic as CarConfigLogicType<ReturnType<typeof setActiveSection>>)({
    type: setActiveSection.type,

    async process({ getState }) {
        if (!isRetailer(getState().commonSettings)) return;
        // For retailer screens:
        // Instead of persisting the active session in the hash, we want to put it in the queryparams
        // Because this way the sections can get SSRed, which improves performance
        const ccSection = getState().carConfigNavigation.activeSection;
        History.replaceQueryParams({ ccSection });
    },
});

export default [setActiveSectionLogic];
